import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=c35cc742&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=c35cc742&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35cc742",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c35cc742')) {
      api.createRecord('c35cc742', component.options)
    } else {
      api.reload('c35cc742', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=c35cc742&scoped=true&", function () {
      api.rerender('c35cc742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26mCb7bH5dRMd/JS/comp/PopupBox.vue"
export default component.exports